


























































































import { Vue, Component } from "vue-property-decorator";
import { UserInvite as IUserInvite } from "@/api/models/user-invite";
import InviteUsersTableItem from "@/components/invite-users/InviteUsersTableItem.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({ components: { InviteUsersTableItem } })
export default class InviteUsers extends Vue {
  firstName!: string | undefined;
  lastName!: string | undefined;
  middleName!: string | undefined;
  email!: string | undefined;
  phone!: string;
  userInviteList: Array<IUserInvite> = [];

  data() {
    return {
      firstName: undefined,
      lastName: undefined,
      middleName: undefined,
      email: undefined,
      phone: undefined
    };
  }

  clearForm() {
    this.firstName = undefined;
    this.lastName = undefined;
    this.middleName = undefined;
    this.email = undefined;
    this.phone = "";
  }

  addUserToList() {
    if (this.email) {
      let currentUser: IUserInvite;
      currentUser = {
        firstName: this.firstName,
        lastName: this.lastName,
        middleName: this.middleName,
        email: this.email,
        phone: this.phone
      };
      this.userInviteList.push(currentUser);
      this.clearForm();
    }
  }

  sendInvites() {
    api.UsersApi.invite(this.userInviteList)
      .then(() => {
        this.$store.dispatch("successToast", {
          message: `${this.$tc(
            this.$translate.RegistrationLinksWereSentToEmail
          )}`
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  removeUser(index: number) {
    this.userInviteList.splice(index, 1);
  }
  get screenWidth() {
    return window.innerWidth;
  }
}
